<template>
  <div>
    <h2 class="page-title">새로 나온 선물</h2>
            <div class="over-hidden">
                <div class="mymenu-box">
                    <ul class="mymenu mymenu01">
                        <!-- 상품 개수는 5개. 등록된 상품이 5개 미만인 경우 공란은 <li>&nbsp;</li>로 -->
                        <slick :options="slickOption">
                        <li>
                            <div class="menu-info">
                                <a >
                                    <div class="img-box">
                                        <img src="@/assets/img/img-sample01.png">
                                    </div>
                                    <span>민트초코칩밀크티+펄</span>
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="menu-info">
                                <a >
                                    <div class="img-box">
                                        <img src="@/assets/img/img-sample02.png">
                                    </div>
                                    <span>민트쿠키스무디</span>
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="menu-info">
                                <a >
                                    <div class="img-box">
                                        <img src="@/assets/img/img-sample03.png">
                                    </div>
                                    <span>자몽QQ크러쉬</span>
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="menu-info">
                                <a >
                                    <div class="img-box">
                                        <img src="@/assets/img/img-sample04.png">
                                    </div>
                                    <span>자몽요구르트크러쉬</span>
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="menu-dimmed"><span>SOLD OUT</span></div>
                            <div class="menu-info">
                                <a >
                                    <div class="img-box">
                                        <img src="@/assets/img/img-sample03.png">
                                    </div>
                                    <span>자몽QQ크러쉬</span>
                                </a>
                            </div>
                        </li>
                        </slick>
                    </ul>
                </div>
            </div>
  </div>
</template>
<script>
import Slick from 'vue-slick';
export default {
  components:{Slick},
  data(){
    return {
      slickOption: {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true
      },
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/giftshop/common/RecommendBottom.vue